import React from 'react';

import { keyDown } from 'components/Controls/CustomIdSelect/CustomIdSelectComponent';
import { stringAsUUID } from 'helpers';
import { stopPropagation } from 'utils/dom';

// components
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Add from '@material-ui/icons/Add';
import { ArrowDownIcon } from 'components/Controls';
// styles
import contentStyles, { MenuProps } from 'styles';
import useStyles from './NetworkIdSelectStyle';

interface Props {
  changeHandler: (chosenNetworkId?: string) => void;
  selected?: string;
}

const Component = (props: Props): JSX.Element => {
  const classes = {
    ...contentStyles(),
    ...useStyles()
  };

  const [values, setValues] = React.useState<string[]>([]);
  const [inputValue, setInputValue] = React.useState<string>('');

  if (props.selected && !values.includes(props.selected)) {
    setValues([...values, props.selected]);
  }

  const handleItemAdd = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    event.stopPropagation();
    if (!inputValue) {
      return;
    }

    const network = stringAsUUID(inputValue);
    if (!values.includes(network)) {
      setValues([network, ...values]);
    }

    setInputValue('');
    props.changeHandler(network);
  };

  const handleItemChange = (event: React.ChangeEvent<{ value: string }>) => {
    const value = String(event.target.value);
    const clearValue = value.trim().replace(/[^A-Za-z0-9]+/g, '');
    setInputValue(clearValue);
  };

  const handleItemSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = String(event.target.value);
    props.changeHandler(value !== props.selected ? value : undefined);
  };

  const onClose = () => props.changeHandler(props.selected);
  return (
    <FormControl
      className={ classes.formControl }
      data-testid="custom-id-select"
    >
      <InputLabel htmlFor="network-label-placeholder"> Position Network ID </InputLabel>
      <Select
        placeholder="Position Network ID"
        value={ props.selected || '' }
        onChange={ handleItemSelect }
        input={ <Input name="network" id="network-label-placeholder"/> }
        name="network"
        renderValue={ (selected) => selected ? String(selected) : '' }
        MenuProps={ MenuProps }
        IconComponent={ (prop) => (<InputAdornment { ...prop } position="end">
          <ArrowDownIcon/>
        </InputAdornment>) }
        onClose={ onClose }
      >
        <div className={ classes.dropDownInput } onKeyDown={ keyDown } onClick={ stopPropagation }>
          <TextField
            value={ inputValue }
            autoFocus={ true }
            placeholder="Enter network ID"
            onKeyDown={ keyDown }
            onClick={ stopPropagation }
            className={ classes.inputFullWidth }
            onChange={ handleItemChange }
            helperText={ stringAsUUID(inputValue) }
            fullWidth
          />
          <Button
            aria-label="Add"
            disabled={ !inputValue }
            color="primary"
            variant="contained"
            className={ classes.buttonAddInSelect }
            onKeyDown={ keyDown }
            onClick={ handleItemAdd }
          >
            <Add/>
          </Button>
        </div>
        { values.map((net) => (
          <MenuItem key={ net } value={ net } className={ classes.listNetId }>
            <Checkbox checked={ props.selected === net }/>
            <ListItemText primary={ <Typography variant="caption">{ net }</Typography> }/>
          </MenuItem>
        )) }
      </Select>
    </FormControl>
  );
};

export default Component;
